import React from 'react';
import { Box, Image, Text, Tooltip } from '@wix/design-system';
import { getClientImageURL, isExternalDashboard } from '../../..';
import { ExternalLinkSmall } from '@wix/wix-ui-icons-common';
import type { BundleWebSolution } from '@wix/ambassador-marketplace/types';
import type { ManagedApp } from '@wix/ambassador-devcenter-managedapps-v1-managed-app/types';
import { AppBadge } from '../app-badge/app-badge';
import { useTranslation } from '../../../hooks/use-translation';

export function AppIntro(props: {
  app: ManagedApp;
  bundleApps: BundleWebSolution[];
  isActionRequiredApp: boolean;
  siteIsPremium: boolean;
  siteIsBusinessFirstSite: boolean;
}) {
  const {
    app,
    bundleApps,
    isActionRequiredApp,
    siteIsPremium,
    siteIsBusinessFirstSite,
  } = props;
  const appName = app?.appInfo?.name;
  const appIconSrc = app?.appInfo?.icon;
  const shouldShowExternalSign =
    isExternalDashboard(app) && !isActionRequiredApp;
  const shouldShowBadge = !isActionRequiredApp;
  const planName = app?.premiumInfo?.planName;
  const shouldShowPlanName = !isActionRequiredApp && app?.premiumInfo?.planName;
  return (
    <Box align="center" verticalAlign="middle">
      <span
        style={{
          height: '36px',
          width: '36px',
          borderRadius: '6px',
          border: '1px solid rgb(240, 244, 247)',
          boxSizing: 'border-box',
        }}
      >
        <Image
          width={36}
          height={36}
          src={getClientImageURL(appIconSrc, {
            originalWidth: 1000,
            originalHeight: 1000,
            toWidth: 36,
            toHeight: 36,
          })}
        />
      </span>
      <Box direction="vertical" marginTop="-4px">
        <Box
          marginLeft="12px"
          direction="horizontal"
          dataHook={appName}
          align="space-between"
        >
          <Box direction="vertical">
            <Box direction="horizontal">
              <Text size="medium" weight="bold" skin="standard">
                {appName}
              </Text>
              {shouldShowExternalSign && (
                <Box marginLeft="2px" marginTop="4px">
                  <ExternalAppSign />
                </Box>
              )}
              {shouldShowBadge && (
                <Box marginLeft="6px" marginTop="2px">
                  {/* @ts-expect-error */}
                  <AppBadge
                    app={app}
                    siteIsPremium={siteIsPremium}
                    siteIsBusinessFirstSite={siteIsBusinessFirstSite}
                    bundleApps={bundleApps}
                  />
                </Box>
              )}
            </Box>
            {shouldShowPlanName && (
              <Box marginTop="-2px">
                <PlanName planName={planName} />
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export function ExternalAppSign() {
  const t = useTranslation();

  return (
    <Tooltip content={t('manage-apps.app-card.app-intro.external-new')}>
      <ExternalLinkSmall data-hook="external-sign" />
    </Tooltip>
  );
}

export function PlanName({ planName }) {
  const t = useTranslation();

  return (
    <Text secondary size="tiny">
      {t('manage-apps.app-card.app-intro.plan-text', { planeName: planName })}
    </Text>
  );
}
